module.exports = __webpack_public_path__ + "img/List_Line_16px_Icon.3b3fc1c0.svg";